<script>import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const GameShowsTabIcon = getIcon("GameShowsTabIcon");
export let size = 17;
export let active = false;
export let hover = false;
export let color = void 0;
</script>

{#if typeof GameShowsTabIcon === 'string'}
	<img src={GameShowsTabIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof GameShowsTabIcon === 'function'}
	<svelte:component this={GameShowsTabIcon} {size} {active} {hover} {color} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
